import { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getIsNameTagInitSuccessful, getIsUngatedForNametag
// @ts-expect-error file not converted to TS yet
} from 'LoginUI/selectors/TwoFactorRecovery';
import { getToken } from 'LoginUI/selectors/TwoFactorAuth';
import { initNameTagRecovery, initNameTagRecoveryCancel } from 'LoginUI/actions/twoFactorRecovery';
export const useNametagRecovery = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  // selectors
  const isUngatedForNametag = useSelector(getIsUngatedForNametag);
  const token = useSelector(getToken);
  const isNameTagInitSuccessful = useSelector(getIsNameTagInitSuccessful);

  // on mount
  useEffect(() => {
    if (token === null) {
      history.push('/');
    }
  }, [token, history]);

  // callbacks
  const handleNametagRecoveryInit = useCallback(() => {
    if (token) {
      void dispatch(initNameTagRecovery(token));
    }
  }, [token, dispatch]);
  const handleNametagRecoveryCancel = useCallback(() => {
    void dispatch(initNameTagRecoveryCancel({}));
  }, [dispatch]);
  return {
    handleNametagRecoveryInit,
    handleNametagRecoveryCancel,
    isUngatedForNametag,
    isNameTagInitSuccessful,
    token
  };
};